export default {
  rwd(prop, prfx) {
    const style = []
    if (typeof this[prop] === 'object') {
      for (const bp in this[prop]) {
        const classes =
          bp === 'default'
            ? `${prfx}${this[prop][bp]}`
            : `${prfx}${this[prop][bp]}-${bp}`
        style.push(classes)
      }
    } else if (this[prop] !== null) {
      style.push(`${prfx}${this[prop]}`)
    }
    return style.join(' ')
  },
  getClass(classes) {
    return classes.join(' ')
  }
}
